import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import icons from '../../themes/assets';
import { NotificationAvatarIcons } from './NotificationAvatarIcons';
import styles from './styles';

export class NotificationAvatar extends React.PureComponent {
  /**
   * @name react lifecycle method render
   */
  render() {
    const {
      classes: { avatarContainer },
      notification,
    } = this.props;
    const avatarBGColor = this.getAvatarBGColor(notification);
    return (
      <div className={avatarContainer} style={{ backgroundColor: avatarBGColor }}>
        <div>{this.renderAvatarIcon()}</div>
      </div>
    );
  }

  /**
   * @renderAvatarIcon
   * @description Renders Icon for notification avatar
   */
  renderAvatarIcon = () => {
    const { notification } = this.props;
    const avatarIcon = NotificationAvatarIcons[notification.alertcategory];
    const styleIcon = code =>
      code.replace(/width=".*?"/g, 'width="2.5em"').replace(/height=".*?"/g, 'height="2.5em"');
    const iconSrc = notification.icon[0].day.replace('@icon.', '').replace('.', '_').replace('.', '_'); // System.Alert.blue
    return (
      <img
        src={icons[iconSrc]}
        alt={notification.alertcategory}
      />
    // <SVG
    //   description={notification.alertcategory}
    //   title={notification.alertcategory}
    //   preProcessor={styleIcon}
    //   uniqueHash={notification.messageid}
    //   uniquifyIDs
    // src={avatarIcon.icon}
    // />
    );
  };

  /**
   * @name getAvatarClass
   * @description returns the style(Css) class for a given
   * notification type's avatar block as per HMI
   */
  getAvatarBGColor = notification => {
    const avatarIcon =
      NotificationAvatarIcons[notification.alertcategory] ||
      NotificationAvatarIcons.CALENDAR_ALERT;
    return avatarIcon.fillColor;
  };
}

NotificationAvatar.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  notification: PropTypes.any.isRequired,
};

export default withStyles(styles)(withTranslation()(NotificationAvatar));
